import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./auth-slice";
import notificationReducer from "./notification-slice";

const store = configureStore({
  reducer: {
    auth: authReducer,
    notification:notificationReducer
  },
});

export default store;
